"use client"

import dynamic from 'next/dynamic'
import { useEffect, useRef, useState } from 'react'
import SpinnerBlock from '@components/spinner/SpinnerBlock'

const ClientMap = dynamic(
    () => import('@components/map/ClientMap'),
    {
        ssr: false,
        loading: () => <SpinnerBlock height={400} />,
    }
)

// wystarczy zapas w rootMargin, żeby mapa zdążyła się zamontować, zanim dojedzie do niej scroll
const LAZY_ROOT_MARGIN = '400px 0px'

const Map = (props) => {
    const [isNearViewport, setIsNearViewport] = useState(false)
    const placeholderRef = useRef(null)

    useEffect(() => {
        if (isNearViewport) return
        const el = placeholderRef.current
        if (!el) return

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) setIsNearViewport(true)
        }, { rootMargin: LAZY_ROOT_MARGIN })

        observer.observe(el)
        return () => observer.disconnect()
    }, [isNearViewport])

    if (!isNearViewport) {
        return <div ref={placeholderRef} style={{ minHeight: props.height || 400, width: '100%' }} />
    }

    return <ClientMap {...props} />
}

export default Map